import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import { deleteACompany, loadCompanysData, saveACompany, updateACompany, clearCompanyErrorMsg } from "../../redux/modules/company";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import InputMask from 'react-input-mask'
//import {loadCamerasData} from "../../redux/modules/camera";
import { withStyles } from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardVehicleInformation from "./CardVehicleInformation";
import CardCompanyInformation from "./CardCompanyInformation";
import * as MainConstants from "../../utils/MainConstants";
import { DEFAULT_VESPAAN_SERVER } from "../../utils/MainConstants";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#e2580d",
        color: "black",
        textTransform: "unset !important",
        width: '80%',
    },
    gridList: {
        width: '100%',
        height: '100%',
    },
});


/*
private String id;
    private String ein;
    private String userId;
    private String name;
    private String address1;
    private String address2;
    private String city;
    private String state;
    private String country;
    private String zipCode;
    private String type;
    private String phone;
    private String email;
 */

class CompanyInfoForm extends React.Component {


    state = {

        //selectedLocation:{},
        selectedCompany: { "id":"", "country": "U.S.A", "state": "Massachusetts" },
        inputFieldShrinkState: true,
        numberShrink: false, //Jut sfor alter I can add a shrink flag for each filed.
        showCompanySavedDialog: false

    };



    constructor(props) {
        super(props);
        this.companyCardList = null;
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        //this.handleCompanyNumberChange = this.handleCompanyNumberChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        //this.handleBankNameChange = this.handleBankNameChange.bind(this);

        this.handleAddress2Change = this.handleAddress2Change.bind(this);

        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleEinChange = this.handleEinChange.bind(this);

        this.handleFaxChange = this.handleFaxChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleTimeZoneChange = this.handleTimeZoneChange.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.handleWebChange = this.handleWebChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);

        this.handleClickShowSavedCompany = this.handleClickShowSavedCompany.bind(this);
        this.handleClickShowSavedCompanyClose = this.handleClickShowSavedCompanyClose.bind(this);



    }


    handleClickShowSavedCompany() {
        this.setState({ showCompanySavedDialog: true });
    };


    handleClickShowSavedCompanyClose() {
        let { clearCompanyErrorMsg } = this.props;
        this.setState({ showCompanySavedDialog: false });
        clearCompanyErrorMsg();
    };

    handleSubmit() {
        let { saveACompany } = this.props;
        var tempStream = this.state.selectedCompany;
        //tempStream.locationId= this.state.selectedLocation.id;
        saveACompany(DEFAULT_VESPAAN_SERVER.url, tempStream);

    };

    handleUpdate() {
        let { updateACompany } = this.props;
        var tempStream = this.state.selectedCompany;
        //tempStream.locationId= this.state.selectedLocation.id;
        updateACompany(DEFAULT_VESPAAN_SERVER.url, tempStream);

    };



    handlePhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { phone: event.target.value }));
    }
    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { zipcode: event.target.value }));
    }
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { country: event.target.value }));
    }

    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { state: event.target.value }));
    }


    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { city: event.target.value }));
    }

    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { address2: event.target.value }));
    }

    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { address1: event.target.value }));
    }

    /* handleCompanyNumberChange(event) {
         //event.preventDefault();
         this.setState(Object.assign(this.state.selectedCompany,{firstName:event.target.value}));
     }
         */

    handleNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { name: event.target.value }));
    }

    /*handleCompanyNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany,{accountName:event.target.value}));
    }*/

    handleEmailChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { email: event.target.value }));
    }

    handleEinChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { ein: event.target.value }));
        this.setState({ numberShrink: true });
    }

    handleFaxChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { fax: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleTypeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { type: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleTimeZoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { timezone: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleLogoChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { companylogolink: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleWebChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCompany, { webpagelink: event.target.value }));
        this.setState({ numberShrink: true });
    }






    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({ selectedLocation: event.target.value });
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }


    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState: true
        }));


        var tempSelectedCompany = Object.assign({}, this.state.selectedCompany);
        Object.keys(tempSelectedCompany).map((key, index) => {
            tempSelectedCompany[key] = "";
        });
        this.setState({ selectedCompany: tempSelectedCompany })




    };
    renderErrorFiled(data) {


    }

    refresh(event) {
        let { loadCompanysData } = this.props;
        loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
    }

    getListOfCompanies() {
        let tempArray = this.props.companysArray;
        let returnArray = [];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                s.editMode = false;
                return (<CardCompanyInformation info={s} onEdit={this.editRecord} onDelete={this.deleteRecord}></CardCompanyInformation>);
            });
        }
        return (returnArray);
    }


    render() {
        const { classes } = this.props;
        this.companyCardList = this.getListOfCompanies()
        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    Company Information
        </Typography>
                <Grid container spacing={24}>
                    <Grid item xs={12} sm={12}>

                        <Grid container >

                            <Grid item xs={6} sm={6}>
                                {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}

                                {/*
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedCompany.accountNumber} onChange={this.handleNumberChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="name" name="name"  label="Name on the account"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCompany.accountName} onChange={this.handleCompanyNameChange}/>
                </Grid>
            </Grid>
            */}

                                <Grid container >
                                    <Grid item xs={5} sm={5}>
                                        <TextField required id="companyname" name="companyname" label="Company Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.name} onChange={this.handleNameChange} />
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>
                                    <Grid item xs={5} sm={5} >
                                        <TextField required id="TaxId" name="TaxId" label="Tax ID (EIN)" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.ein} onChange={this.handleEinChange} />
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField required id="address1" name="address1" label="Address line 1" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.address1} onChange={this.handleAddress1Change} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField id="address2" name="address2" label="Address line 2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.address2} onChange={this.handleAddress2Change} />
                                </Grid>
                                <Grid container >
                                    <Grid item xs={5} sm={5} >
                                        <TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.city} onChange={this.handleCityChange} />
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>
                                    <Grid item xs={5} sm={5} >
                                        {/*<TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCompany.state} onChange={this.handleStateChange}/>
                                    */}
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="age-helper">State</InputLabel>
                                            <Select value={this.state.selectedCompany.state}
                                                onChange={this.handleStateChange}
                                                inputProps={{
                                                    name: 'state',
                                                    id: 'state-helper',
                                                }}
                                            >

                                                {(this.state.selectedCompany.country == "U.S.A") && (usStates)}
                                                {(this.state.selectedCompany.country != "U.S.A") && (canStates)}


                                            </Select>
                                            {/* <FormHelperText>Select a State </FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={5} sm={5}>
                                        <TextField required id="zip" name="zip" label="Zip / Postal code" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.zipcode} onChange={this.handleZipcodeChange} />
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>
                                    <Grid item xs={5} sm={5}>
                                        {/*<TextField  required id="country"  name="country"  label="Country"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCompany.country} onChange={this.handleCountryChange} />
                                */}<FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="age-helper">Country</InputLabel>
                                            <Select value={this.state.selectedCompany.country}
                                                onChange={this.handleCountryChange}
                                                inputProps={{
                                                    name: 'country',
                                                    id: 'country-helper',
                                                }}
                                            >

                                                {availableCountries}

                                            </Select>

                                        </FormControl>

                                    </Grid>



                                    <Grid item xs={5} sm={5}>
                                        <InputMask mask="(999) 999-9999" value={this.state.selectedCompany.phone} onChange={this.handlePhoneChange}  >
                                            {() => <TextField required id="phone" name="phone" label="Phone" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} />}
                                        </InputMask>
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>

                                    <Grid item xs={5} sm={5}>
                                        <TextField required id="email" name="email" label="Email" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.email} onChange={this.handleEmailChange} />
                                    </Grid>


                                    <Grid item xs={5} sm={5}>
                                        <InputMask mask="(999) 999-9999" value={this.state.selectedCompany.fax} onChange={this.handleFaxChange} >
                                            {() => <TextField required id="phone" name="Fax" label="Fax" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} />}
                                        </InputMask>
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>



                                    {/*
        <Grid item xs={5} sm={5}>
            <TextField  required id="TimeZone"  name="TimeZone"  label="Time Zone"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCompany.timezone} onChange={this.handleTimeZoneChange} />
        </Grid>
        <Grid item xs={2} sm={2} >
            </Grid>

            <Grid item xs={5} sm={5}>
            <TextField  required id="logo"  name="logo"  label="Company Logo"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCompany.companylogolink} onChange={this.handleLogoChange} />
        </Grid>
        */}

                                    <Grid item xs={5} sm={5}>
                                        <TextField required id="WebAddress" name="WebAddress" label="Web Address" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedCompany.webpagelink} onChange={this.handleWebChange} />
                                    </Grid>

                                    <Grid item xs={5} sm={5}>
                                        {/* <TextField  required id="Type"  name="Type"  label="Type"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCompany.type} onChange={this.handleTypeChange} />
                                            */}
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>

                                    <Grid item xs={5} sm={5}>
                                        {/* empty for now we can later*/}
                                    </Grid>



                                    <Grid item xs={6} sm={6}>
                                        {((this.state.selectedCompany.id === undefined) || (this.state.selectedCompany.id === "")) && (
                                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                                            Add Company
                                        </Button>)}
                                    </Grid>
                                    <Grid item xs={6} sm={6}>
                                        {(this.state.selectedCompany.id !== '') &&(
                                          <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                                            Update Company
                                        </Button>)}
                                    </Grid>
                                    <Grid item xs={6} sm={6}>
                                        <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                                            Clear Fields
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} sm={6}>
                                        <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                                            Refresh
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={1} sm={1}>
                            </Grid>
                            <Grid item xs={5} sm={5}>
                                {/*<DynamicTable  data={this.props.companysArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
                                <Typography variant="h6" gutterBottom>
                                    There are {this.props.companysArray.length}  companies in your profile.
                                </Typography>

                                <GridList cellHeight={100} className={classes.gridList}>
                                    {this.companyCardList}
                                </GridList>
                            </Grid>
                        </Grid>



                        <Grid container >
                            {/*} {(this.props.errorCMsg) && (this.props.errorCMsg.message) && (
                                <Grid item xs={12}   >
                                    <TextField error id="outlined-error" label="Error - Operation Failed" value={" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " + this.props.errorCMsg.timestamp}
                                        className={classes.textField} margin="normal" variant="outlined" disabled={true} multiline={true} />
                                </Grid>)
                            } */}

                            {/*
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */}
                        </Grid>
                    </Grid>
        {/* This is for submit event error/success display */}
    <Dialog
        open={this.state.showCompanySavedDialog}
        onClose={this.handleClickShowSavedCompanyClose}
        scroll={'paper'}
        classes={{
            paper: classes.formControl2,
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="xl"
          >
          <DialogTitle id="scroll-dialog-title">Company Information</DialogTitle>
        <DialogContent id="farshids" dividers="paper">
      
          {(this.props.errorCMsg.status == 200) && (<div>
        The Operation was SUCCESSFUL!  Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
        </div>)}
            {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
            The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
            </div>)}
        
            </DialogContent>
            <DialogActions>
            {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
        
            <Button onClick={this.handleClickShowSavedCompanyClose} color="secondary">Close</Button>
              </DialogActions>
              </Dialog>


                </Grid>
            </React.Fragment>
        );
    }//end of render



    editRecord(singleRowData) {
        this.setState({ inputFieldShrinkState: true });
        this.setState({ selectedCompany: singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );

        //this.setState({selectedLocation:tempLocation });

    }


    deleteRecord(argProcessId) {
        //alert('I am deleting ' + argCameraId);
        let { deleteACompany } = this.props;
        deleteACompany(DEFAULT_VESPAAN_SERVER.url, argProcessId);
    }


    componentWillMount() {
        let { loadCompanysData, loadLocationsData } = this.props;
        loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
        //loadLocationsData("http://localhost:9065/" );

        this.setState({
            errorCMsg: {}
        });


    }

    componentWillReceiveProps(nextProps) {
        if (this.props.companysArray !== nextProps.companysArray) {
            this.setState({
                companysArray: nextProps.companysArray
            });
        }
        if (nextProps.errorCMsg.status != null) {
            if (nextProps.errorCMsg.status != null) {
                this.handleClickShowSavedCompany();
            }
        }
    }



}//end of class

CompanyInfoForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        companysArray: state.company.companysArray,
        CompanyDeleteResponse: state.company.deleteCompanyResp,
        CompanySaveResponse: state.company.saveCompanyResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg: state.company.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadCompanysData: loadCompanysData,
        deleteACompany: deleteACompany,
        saveACompany: saveACompany,
        updateACompany: updateACompany,
        clearCompanyErrorMsg: clearCompanyErrorMsg,

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CompanyInfoForm));
